import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    AppBar, Toolbar, Typography, Button, IconButton, Drawer,
    List, ListItem, ListItemText, Box, useMediaQuery, useTheme
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const navLinks = [
    { label: 'How to Play', path: '/how-to-play' },
    { label: 'Strategy', path: '/strategy' },
    { label: 'FAQ', path: '/faq' },
    { label: 'About', path: '/about' },
];

const Header = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <AppBar position="static" elevation={0} sx={{ backgroundColor: '#0B2A21', borderBottom: '1px solid rgba(243, 238, 226, 0.1)' }}>
            <Toolbar sx={{ maxWidth: 1200, width: '100%', margin: '0 auto', px: { xs: 1, md: 2 } }}>
                <span className="brand-mark" aria-hidden="true" style={{ marginRight: 10 }}><span/><span/><span/></span>
                <Typography
                    variant="h6"
                    component={Link}
                    to="/"
                    sx={{
                        flexGrow: 1,
                        textDecoration: 'none',
                        color: '#fff',
                        fontWeight: 700,
                        letterSpacing: '0.5px'
                    }}
                >
                    Play Sequence
                </Typography>

                {isMobile ? (
                    <>
                        <IconButton color="inherit" onClick={() => setDrawerOpen(true)}>
                            <MenuIcon />
                        </IconButton>
                        <Drawer
                            anchor="right"
                            open={drawerOpen}
                            onClose={() => setDrawerOpen(false)}
                            PaperProps={{ sx: { backgroundColor: '#0B2A21', width: 250 } }}
                        >
                            <Box sx={{ pt: 2 }}>
                                <List>
                                    {navLinks.map((link) => (
                                        <ListItem
                                            key={link.path}
                                            component={Link}
                                            to={link.path}
                                            onClick={() => setDrawerOpen(false)}
                                            sx={{
                                                color: location.pathname === link.path ? '#E2B65B' : 'rgba(255,255,255,0.8)',
                                                '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.05)' }
                                            }}
                                        >
                                            <ListItemText primary={link.label} />
                                        </ListItem>
                                    ))}
                                    <ListItem sx={{ mt: 1, px: 2 }}>
                                        <Button
                                            component={Link}
                                            to="/"
                                            variant="contained"
                                            fullWidth
                                            sx={{
                                                backgroundColor: '#E2B65B', color: '#16201C',
                                                fontWeight: 700,
                                                '&:hover': { backgroundColor: '#CDA049' }
                                            }}
                                        >
                                            Play Now
                                        </Button>
                                    </ListItem>
                                </List>
                            </Box>
                        </Drawer>
                    </>
                ) : (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {navLinks.map((link) => (
                            <Button
                                key={link.path}
                                component={Link}
                                to={link.path}
                                sx={{
                                    color: location.pathname === link.path ? '#fff' : 'rgba(255,255,255,0.7)',
                                    fontWeight: location.pathname === link.path ? 700 : 400,
                                    textTransform: 'none',
                                    fontSize: '0.95rem',
                                    '&:hover': { color: '#fff' }
                                }}
                            >
                                {link.label}
                            </Button>
                        ))}
                        <Button
                            component={Link}
                            to="/"
                            variant="contained"
                            sx={{
                                ml: 1,
                                backgroundColor: '#E2B65B', color: '#16201C',
                                fontWeight: 700,
                                textTransform: 'none',
                                '&:hover': { backgroundColor: '#CDA049' }
                            }}
                        >
                            Play Now
                        </Button>
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Header;
